module.exports = __webpack_public_path__ + "static/media/pen-alt.a08f73ad.svg";